/**
 * @generated SignedSource<<499640134c059cda78a66e71c8059b7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type longReadArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleLandingBannerArticle" | "blockquoteLongReadContent" | "globalCheckerContent">;
  readonly " $fragmentType": "longReadArticleArticle";
};
export type longReadArticleArticle$key = {
  readonly " $data"?: longReadArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"longReadArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "longReadArticleArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleLandingBannerArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "blockquoteLongReadContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "c37b059f2b7815fcb824f1b0f4384ef9";

export default node;
